import { useChatStore } from '../../stores/chatStore';
import { selectDmUnread, useDmStore } from '../../stores/dmStore';
import { selectMissedRingCount, useMissedRingsStore } from '../../stores/missedRingsStore';

/**
 * Was am Chat-Knopf als Zahl steht: ungelesene Raumnachrichten,
 * Direktnachrichten und verpasste Klingelversuche. Letztere zaehlen mit,
 * weil die Karte von einem Dialog verdeckt sein kann — die Zahl am Chat
 * bleibt sichtbar.
 */
export function useChatUnread(): number {
  const unread = useChatStore((s) => s.unread);
  const dmUnread = useDmStore(selectDmUnread);
  const missedRings = useMissedRingsStore(selectMissedRingCount);
  return unread + dmUnread + missedRings;
}
